import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ServiceAppointment as Appointment, Vehicle  } from '@quorum/models/xs-resource';
import { ApiService } from '@quorum/api';
import { Associate } from '@quorum/models/xs-resource';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'svc-appointment-match-summary',
  templateUrl: './appointment-match-summary.component.html',
  styleUrls: ['./appointment-match-summary.component.scss'],
})
export class AppointmentMatchSummaryComponent implements OnInit {
  @Input() appointment: Appointment;
  @Input() vehicle: Vehicle;
  @Input() associate: Associate;
  customerEquityValue: boolean = false;
  vehicleImage: SafeResourceUrl;
  constructor(private apiService: ApiService, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    //console.log('test');
    if (this.vehicle.id) {
      this.apiService
        .get(`v/1/reporting/crm/available`, { params: { vehicleId: this.vehicle.id } })
        .pipe(map((vehicleReport) => (vehicleReport.length == 1 ? vehicleReport[0] : null)))
        .subscribe((equityData) => {
          if (equityData != null && equityData.equityValue > 0) {
            this.customerEquityValue = equityData.equityValue;
          }
        });
    }

    this.apiService
      .get(`/v/1/reporting/vehicles/image/${this.vehicle.vin}?size=large`)
      .pipe(take(1))
      .subscribe((photo) => {
        if (photo.file_contents) {
          this.vehicleImage = this.sanitizer.bypassSecurityTrustResourceUrl(
            `data:image/jpg;base64,${photo.file_contents}`
          );
        } else {
          this.vehicleImage = null;
        }
      });
  }
}
